// SPDX-FileCopyrightText: 2026 Stadtplatz.de
//
// SPDX-License-Identifier: EUPL-1.2

import apiClient from "../config/api";
import { buildParams, handleApiCall } from "../utils/apiHelper";

const scenarioService = {
  async getScenarios(params = {}) {
    const queryParams = buildParams({
      page: params.page || 1,
      limit: params.limit || 25,
      location_id: params.location_id,
      tenantId: params.tenant_id ?? params.tenantId,
      search: params.search,
      include_inactive: params.include_inactive,
    });

    return handleApiCall(
      () => apiClient.get("/admin/scenarios/", { params: queryParams }),
      "Error fetching scenarios",
    );
  },

  async getScenarioById(scenarioId) {
    return handleApiCall(
      () => apiClient.get(`/admin/scenarios/${scenarioId}`),
      `Error fetching scenario ${scenarioId}`,
    );
  },

  async createScenario(payload) {
    return handleApiCall(
      () => apiClient.post("/admin/scenarios/", payload),
      "Error creating scenario",
    );
  },

  async updateScenario(scenarioId, payload) {
    return handleApiCall(
      () => apiClient.put(`/admin/scenarios/${scenarioId}`, payload),
      `Error updating scenario ${scenarioId}`,
    );
  },

  async deleteScenario(scenarioId) {
    return handleApiCall(
      () => apiClient.delete(`/admin/scenarios/${scenarioId}`),
      `Error deleting scenario ${scenarioId}`,
    );
  },
};

export default scenarioService;
